module.exports = __webpack_public_path__ + "img/image_marker_notification.043ef6aa.svg";